export var PermissionEn;
(function (PermissionEn) {
    PermissionEn["read"] = "READ";
    PermissionEn["viewDetail"] = "VIEW_DETAIL";
    PermissionEn["create"] = "CREATE";
    PermissionEn["update"] = "UPDATE";
    PermissionEn["delete"] = "DELETE";
    PermissionEn["import"] = "IMPORT";
    PermissionEn["export"] = "EXPORT";
    PermissionEn["approve"] = "APPROVE";
    PermissionEn["reject"] = "REJECT";
    PermissionEn["approve_solution"] = "APPROVE_SOLUTION";
    PermissionEn["assign"] = "ASSIGN";
    PermissionEn["create_leave_ticket"] = "CREATE_LEAVE_TICKET";
    PermissionEn["admin"] = "ADMIN";
    PermissionEn["get_qr"] = "GET_QR";
    PermissionEn["config_field"] = "CONFIG_FIELD";
    PermissionEn["confirm_transportation"] = "CONFIRM_TRANSPORTATION";
})(PermissionEn || (PermissionEn = {}));
